export default class Camera {
  constructor() {}

  Draw() {
    console.warn("This method should be overwritten");
  }
}
